<gen-options-button class='export-worklist-data-wrapper'
                    [dlsTooltip]="getToolTipMessage()"
                    [tooltipPosition]="'Bottom'"
                    [tooltipClass]="'pt-primary'"
                    [tooltipShowDelay]="1"
                    [tooltipHideDelay]="10"
                    [disabled]="disabled"
                    [buttonText]="exportButtonText"
                    [options]="exportDataOptions"
                    [outSideClickClose]="exportOutSideClickClose">
</gen-options-button>
